import JoditEditor from "jodit-react";
import MultipleAddFAQs from "../../../components/Common/MultipleAddFAQs";

const StepTwo = ({
  setValue,
  description,
  setDescription,
  authorDetail,
  setAuthorDetail,
  warning,
  setWarning,
  direction,
  setDirection,
  sideEffect,
  setSideEffect,
  storage,
  setStorage,
  dosage,
  setDosage,
  reference,
  setReference,
  register,
  errors,
  faqs,
  setFaqs,
}) => {
  return (
    <div className="p-4">
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">Description</label>
        <JoditEditor
          value={description}
          onChange={(value) => {
            setDescription(value);
            setValue("description", value);
          }}
        />
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">Author Details</label>
        <JoditEditor
          value={authorDetail}
          onChange={(value) => {
            setAuthorDetail(value);
            setValue("authorDetail", value);
          }}
        />
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">
          Warning and precaution<span className="star"> *</span>
        </label>
        <JoditEditor
          value={warning}
          onChange={(value) => {
            setWarning(value);
            setValue("warning", value);
          }}
        />
        {!warning?.length && (
          <div className={`invalid-feedback d-block`}>
            Please provide a Warning and precaution
          </div>
        )}
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">
          Direction and Uses<span className="star"> *</span>
        </label>
        <JoditEditor
          value={direction}
          onChange={(value) => {
            setDirection(value);
            setValue("direction", value);
          }}
        />
        {!direction?.length && (
          <div className={`invalid-feedback d-block`}>
            Please provide a Direction and Uses
          </div>
        )}
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">
          Side Effects<span className="star"> *</span>
        </label>
        <JoditEditor
          value={sideEffect}
          onChange={(value) => {
            setSideEffect(value);
            setValue("sideEffect", value);
          }}
        />
        {!sideEffect?.length && (
          <div className={`invalid-feedback d-block`}>
            Please provide a Side Effects
          </div>
        )}
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">
          Storage & Disposal<span className="star"> *</span>
        </label>
        <JoditEditor
          value={storage}
          onChange={(value) => {
            setStorage(value);
            setValue("storage", value);
          }}
        />
        {!storage?.length && (
          <div className={`invalid-feedback d-block`}>
            Please provide a Storage & Disposal
          </div>
        )}
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">
          Dosage<span className="star"> *</span>
        </label>
        <JoditEditor
          value={dosage}
          onChange={(value) => {
            setDosage(value);
            setValue("dosage", value);
          }}
        />
        {!dosage?.length && (
          <div className={`invalid-feedback d-block`}>
            Please provide a Dosage
          </div>
        )}
      </div>
      <div className="addnew-form1-desc">
        <label className="title mt-4 fs14fw600">Reference</label>
        <JoditEditor
          value={reference}
          onChange={(value) => {
            setReference(value);
            setValue("reference", value);
          }}
        />
      </div>
      <MultipleAddFAQs
        register={register}
        errors={errors}
        setValue={setValue}
        faqs={faqs}
        setFaqs={setFaqs}
      />
    </div>
  );
};
export default StepTwo;
